/* eslint-disable arrow-body-style */
import { FunctionComponent } from 'react';
import Image from 'next/image';
import { Typography } from '@/components/Atoms';
import { ITaskCategoryData } from '@/types/Achievements';
import styles from './BadgeProgress.module.scss';

interface BadgeProgressProps {
  progressWidth: number;
  badgeSrc: string;
  title: string;
  progressPercentage: number;
  onClick?: (category: ITaskCategoryData | null) => void;
  shouldShowTitle: boolean;
  category: ITaskCategoryData | null;
  isSelected: boolean; // New prop to indicate if the badge is selected
}

const BadgeProgress: FunctionComponent<BadgeProgressProps> = ({
  badgeSrc,
  progressWidth,
  progressPercentage,
  title,
  onClick,
  shouldShowTitle,
  category,
  isSelected,
}) => {
  const isComingSoon = !shouldShowTitle;

  return (
    <div
      className={` ${styles.container} ${isSelected ? styles.selected : ''} ${isComingSoon ? styles.comingSoon : ''}`}
      style={{ width: progressWidth }}
      onClick={() => {
        if (!isComingSoon && onClick) {
          onClick(category); // Only trigger onClick if not coming soon
        }
      }}
    >
      <div className={styles.progress} style={{ width: `${progressWidth}px` }}>
        <div className={styles.badge}>
          <div className={styles.progressFill} style={{ width: `${progressPercentage}%` }}></div>
        </div>
      </div>
      <div className={`overflow-visible  ${styles.badgeWrapper} ${isSelected ? styles.selectedBadgeWrapper : ''}`}>
        <div className={styles.glowWrapper}>
          <div className={isSelected ? styles.glow : ''} />
          <Image
            src={badgeSrc}
            alt={`Badge ${title}`}
            width={100}
            height={60}
            objectFit='contain'
            className={`${styles.imageWrapper} ${isSelected ? styles.selectedImage : ''}`} // Apply the hover class here
          />
        </div>
        <div className={styles.rankPoints}>
          {shouldShowTitle ? (
            <div className='flex flex-col'>
              <Typography size='s12ToS12' className={`${styles.startPoint} ${isSelected ? styles.selectedText : ''}`}>
                {title}
              </Typography>
            </div>
          ) : (
            <Typography size='s12ToS12' className={`${styles.startPoint} ${isSelected ? styles.selectedText : ''}`}>
              Soon
            </Typography>
          )}
        </div>
      </div>
    </div>
  );
};
export default BadgeProgress;
